export default "/assets/images/reading-girl.6738171bc68c6d0e.jpg";